/**
 * @generated SignedSource<<61c19b5ebf8364f07695ae3e9ffb96a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIsLiveArticle$data = {
  readonly flattenTypeIds: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly liveArticle: {
    readonly status: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "helpersCheckIsLiveArticle";
};
export type helpersCheckIsLiveArticle$key = {
  readonly " $data"?: helpersCheckIsLiveArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsLiveArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIsLiveArticle"
};

(node as any).hash = "a7ee619c073a12e20a5a96f7eb08798d";

export default node;
